export const dummyCustomerDetail = {
  customer_id: '01925015-90af-7a5a-b3f3-02c5f41f33b7',
  email: 'jhon.doe@gmail.com',
  dob: '01/01/1995',
  first_name: 'Jhon',
  last_name: 'Doe',
  gender: 'male',
  phone: '08123456789',
  addresses: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
};
